export default "__VITE_ASSET__BFGl63UJ__"